import { depatternize } from '@formatters/patternize';

export default function installments(value = '', options = {}) {
  const minimum = (options.minimum || 1);
  const maximum = (options.maximum || 120);

  const list = String(value || '')
    .split(',')
    .filter((i) => i)
    .map((i) => i.trim());

  return list
    .filter((i) => i && i === depatternize(i) && i >= minimum && maximum)
    .length !== list.length;
}

installments.message = function message(value, options = {}) {
  return options.message || 'precisa ser um (ou mais) prazo(s) válido(s)';
};
